<template>
	<div
		v-if="hasValidType"
		:class="`separator separator--${type}`"
		data-cy="separator"
	>
		<span
			v-if="text"
			:class="`separator-text--${textPosition}`"
			class="separator-text"
		>
			{{ text }}
		</span>
	</div>
</template>

<script>
export default {
	name: 'Separator',

	props: {
		text: {
			type: String,
			required: false,
			default: null,
			description: 'Sets the text that will appear inline with the Separator',
		},

		textPosition: {
			type: String,
			required: false,
			default: 'center',
			validator: value => [
				'center',
				'left',
				'right',
			].indexOf(value) !== -1,
			description: 'Sets the horizontal alignment of the text in the Separator',
		},

		type: {
			type: String,
			required: false,
			default: 'plain',
			validator: value => [
				'dashed',
				'dotted',
				'plain',
			].indexOf(value) !== -1,
			description: 'Sets the type of Separator line',
		},
	},

	data() {
		return {
			hasValidType: false,
		};
	},

	created() {
		this.hasValidType = ['plain', 'dashed', 'dotted'].indexOf(this.type) !== -1;
	},
};
</script>

<style lang="scss" src="./separator.scss" />
